// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__RyKqO","inner":"Footer_inner__3Jf3g","nextIcon":"Footer_nextIcon__2SxL2","innerLeft":"Footer_innerLeft__18qKo"};